import { ISchedule } from '../interfaces/ISchedule';

export const formatSchedule = (schedule: ISchedule): ISchedule => {
  return {
    ...schedule,
    name: schedule.name ? schedule.name : undefined,
    description: schedule.description ? schedule.description : undefined,
  };
};
